// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/customer_support/inquiry/v1/inquiry.proto (package stailer_service_specification.customer_support.inquiry.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { enumDesc, fileDesc, messageDesc, tsEnum } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_enum_description } = require("../../../../description_support/v1/enum_description_pb");
const { file_description_support_v1_field_description } = require("../../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/customer_support/inquiry/v1/inquiry.proto.
 */
const file_stailer_service_specification_customer_support_inquiry_v1_inquiry = /*@__PURE__*/
  fileDesc("CkdzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9jdXN0b21lcl9zdXBwb3J0L2lucXVpcnkvdjEvaW5xdWlyeS5wcm90bxI5c3RhaWxlcl9zZXJ2aWNlX3NwZWNpZmljYXRpb24uY3VzdG9tZXJfc3VwcG9ydC5pbnF1aXJ5LnYxIs8DCgZRYUxpbmsScAoFdGl0bGUYASABKAlCYZKCGUfos6rllY/jgr/jgqTjg4jjg6vjgafjgZnvvIjkvos6IOazqOaWh+OCkuOCreODo+ODs+OCu+ODq+OBl+OBn+OBhO+8ieOAgqqCGRLos6rllY/jgr/jgqTjg4jjg6sSPQoDdXJsGAIgASgJQjCSghkaUUHjg5rjg7zjgrjjga5VUkzjgafjgZnjgIKqghkOUUHjg5rjg7zjgrhVUkwSkwIKE3JlY2VpdmVfbWV0aG9kX3R5cGUYAyABKA4yTC5zdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi5jdXN0b21lcl9zdXBwb3J0LmlucXVpcnkudjEuUmVjZWl2ZU1ldGhvZFR5cGVCpwGSghmMAeOBk+OBrlFB44Oq44Oz44Kv44KS6KGo56S644GZ44KL5Y+X44GR5Y+W44KK5pa55rOV44KS5oyH5a6a44GX44G+44GZ44CC5pyq5oyH5a6a44Gu5aC05ZCI44Gv5Y+X44GR5Y+W44KK5pa55rOV44KS5ZWP44KP44Ga6KGo56S644GX44G+44GZ44CCqoIZEuWPl+OBkeWPluOCiuaWueazlSKgAQoOU3RhaWxlcklucXVpcnkSjQEKC2lucXVpcnlfdXJsGAEgASgJQniSghlXU3RhaWxlcuOBi+OCiemAgeS/oeOBmeOCi2VtYWls44Gr6KiY6LyJ44GZ44KL44GK5ZWP44GE5ZCI44KP44Gb44Oa44O844K444GuVVJM44Gn44GZ44CCqoIZFeOBiuWVj+OBhOWQiOOCj+OBm1VSTMiCGQEioAEKDlplbmRlc2tJbnF1aXJ5Eo0BCgtpbnF1aXJ5X3VybBgBIAEoCUJ4koIZV1N0YWlsZXLjgYvjgonpgIHkv6HjgZnjgotlbWFpbOOBq+iomOi8ieOBmeOCi+OBiuWVj+OBhOWQiOOCj+OBm+ODmuODvOOCuOOBrlVSTOOBp+OBmeOAgqqCGRXjgYrllY/jgYTlkIjjgo/jgZtVUkzIghkBKs8CChFSZWNlaXZlTWV0aG9kVHlwZRJjCh9SRUNFSVZFX01FVEhPRF9UWVBFX1VOU1BFQ0lGSUVEEAAaPuqCGSrlj5fjgZHlj5bjgormlrnms5Xjga7mjIflrprjgarjgZfjgafjgZnjgIL6ghkM5oyH5a6a44Gq44GXEmYKHFJFQ0VJVkVfTUVUSE9EX1RZUEVfREVMSVZFUlkQARpE6oIZNumFjemBlOOBq+OCiOOCi+WPl+OBkeWPluOCiuaZguOBruOBv+ihqOekuuOBl+OBvuOBmeOAgvqCGQbphY3pgZQSbQoaUkVDRUlWRV9NRVRIT0RfVFlQRV9QSUNLVVAQAhpN6oIZM+W6l+iIl+OBp+OBruWPl+OBkeWPluOCiuaZguOBruOBv+ihqOekuuOBl+OBvuOBmeOAgvqCGRLlupfoiJflj5fjgZHlj5bjgopiBnByb3RvMw", [file_description_support_v1_enum_description, file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.customer_support.inquiry.v1.QaLink.
 * Use `create(QaLinkSchema)` to create a new message.
 */
const QaLinkSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_customer_support_inquiry_v1_inquiry, 0);

/**
 * Describes the message stailer_service_specification.customer_support.inquiry.v1.StailerInquiry.
 * Use `create(StailerInquirySchema)` to create a new message.
 */
const StailerInquirySchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_customer_support_inquiry_v1_inquiry, 1);

/**
 * Describes the message stailer_service_specification.customer_support.inquiry.v1.ZendeskInquiry.
 * Use `create(ZendeskInquirySchema)` to create a new message.
 */
const ZendeskInquirySchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_customer_support_inquiry_v1_inquiry, 2);

/**
 * Describes the enum stailer_service_specification.customer_support.inquiry.v1.ReceiveMethodType.
 */
const ReceiveMethodTypeSchema = /*@__PURE__*/
  enumDesc(file_stailer_service_specification_customer_support_inquiry_v1_inquiry, 0);

/**
 * 受け取り方法の種別を表します。
 * QAリンクの表示条件として利用されます。
 *
 * @generated from enum stailer_service_specification.customer_support.inquiry.v1.ReceiveMethodType
 */
const ReceiveMethodType = /*@__PURE__*/
  tsEnum(ReceiveMethodTypeSchema);


exports.file_stailer_service_specification_customer_support_inquiry_v1_inquiry = file_stailer_service_specification_customer_support_inquiry_v1_inquiry;
exports.QaLinkSchema = QaLinkSchema;
exports.StailerInquirySchema = StailerInquirySchema;
exports.ZendeskInquirySchema = ZendeskInquirySchema;
exports.ReceiveMethodTypeSchema = ReceiveMethodTypeSchema;
exports.ReceiveMethodType = ReceiveMethodType;
